import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./i18n";

import WebAppView from "webapp/WebAppView";
import "./index.css";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Dashboard from "portal/Dashboard";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  // <React.StrictMode>
  <React.Suspense fallback={<div className="suspense">Loading</div>}>
    <BrowserRouter>
      <Routes>
        <Route path="/portal" element={<Dashboard />} />
        <Route path="*" element={<WebAppView />} />
      </Routes>
    </BrowserRouter>
  </React.Suspense>,
  // </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
